import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'wth_lang';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        shop: 'Shop',
        collections: 'Collections',
        about: 'About',
        journal: 'Journal',
        contact: 'Contact',
        search: 'Search',
        wishlist: 'Wishlist',
        bag: 'Bag',
        search_placeholder: 'Search for scripture wallets, tees, mugs...',
      },
      common: {
        add_to_bag: 'Add to Bag',
        add_to_cart: 'Add to Cart',
        out_of_stock: 'Out of Stock',
        buy_now: 'Buy Now',
        proceed_to_checkout: 'Proceed to Checkout',
        continue_shopping: 'Continue Shopping',
        remove: 'Remove',
        move_to_bag: 'Move to Bag',
        share: 'Share',
        quick_view: 'Quick View',
        loading: 'Loading...',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        free: 'Free',
        total: 'Total',
        discount: 'Discount',
        added_to_wishlist: 'Added to wishlist',
        removed_from_wishlist: 'Removed from wishlist',
        added_to_bag: 'added to bag',
      },
      product: {
        recommendations: 'You may also love',
        recently_viewed: 'Recently viewed',
        related: 'Related products',
        in_stock: 'In stock',
        rating: 'Rating',
        reviews: 'reviews',
        details: 'Details',
        shipping: 'Shipping',
      },
      wishlist: {
        title: 'Your Wishlist',
        subtitle: 'Saved items just for you',
        empty_title: 'Your wishlist is empty',
        empty_subtitle: 'Save items you love by tapping the heart on any product.',
        browse_shop: 'Browse the shop',
        items_saved: '{{count}} items saved',
        move_all_to_bag: 'Move all to bag',
        clear: 'Clear wishlist',
      },
      cart: {
        title: 'Your Bag',
        empty_title: 'Your bag is empty',
        empty_subtitle: "Let's fill it with hope and grace.",
        clear_bag: 'Clear bag',
        start_shopping: 'Start Shopping',
      },
      footer: {
        newsletter_title: 'Subscribe for hope in your inbox',
        newsletter_placeholder: 'Enter your email',
        subscribe: 'Subscribe',
      },
    },
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        shop: 'Tienda',
        collections: 'Colecciones',
        about: 'Nosotros',
        journal: 'Blog',
        contact: 'Contacto',
        search: 'Buscar',
        wishlist: 'Favoritos',
        bag: 'Bolsa',
        search_placeholder: 'Buscar carteras, camisetas, tazas...',
      },
      common: {
        add_to_bag: 'Añadir a la bolsa',
        add_to_cart: 'Añadir al carrito',
        out_of_stock: 'Agotado',
        buy_now: 'Comprar ahora',
        proceed_to_checkout: 'Ir al pago',
        continue_shopping: 'Seguir comprando',
        remove: 'Quitar',
        move_to_bag: 'Mover a la bolsa',
        share: 'Compartir',
        quick_view: 'Vista rápida',
        loading: 'Cargando...',
        subtotal: 'Subtotal',
        shipping: 'Envío',
        free: 'Gratis',
        total: 'Total',
        discount: 'Descuento',
        added_to_wishlist: 'Añadido a favoritos',
        removed_from_wishlist: 'Eliminado de favoritos',
        added_to_bag: 'añadido a la bolsa',
      },
      product: {
        recommendations: 'También te pueden gustar',
        recently_viewed: 'Vistos recientemente',
        related: 'Productos relacionados',
        in_stock: 'En stock',
        rating: 'Valoración',
        reviews: 'reseñas',
        details: 'Detalles',
        shipping: 'Envío',
      },
      wishlist: {
        title: 'Tus favoritos',
        subtitle: 'Artículos guardados solo para ti',
        empty_title: 'Tu lista de favoritos está vacía',
        empty_subtitle: 'Guarda tus artículos favoritos tocando el corazón en cualquier producto.',
        browse_shop: 'Ver la tienda',
        items_saved: '{{count}} artículos guardados',
        move_all_to_bag: 'Mover todo a la bolsa',
        clear: 'Vaciar favoritos',
      },
      cart: {
        title: 'Tu bolsa',
        empty_title: 'Tu bolsa está vacía',
        empty_subtitle: 'Llénala de esperanza y gracia.',
        clear_bag: 'Vaciar bolsa',
        start_shopping: 'Empezar a comprar',
      },
      footer: {
        newsletter_title: 'Suscríbete para recibir esperanza en tu bandeja',
        newsletter_placeholder: 'Introduce tu email',
        subscribe: 'Suscribirse',
      },
    },
  },
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        shop: 'Boutique',
        collections: 'Collections',
        about: 'À propos',
        journal: 'Journal',
        contact: 'Contact',
        search: 'Rechercher',
        wishlist: 'Favoris',
        bag: 'Panier',
        search_placeholder: 'Rechercher portefeuilles, t-shirts, mugs...',
      },
      common: {
        add_to_bag: 'Ajouter au panier',
        add_to_cart: 'Ajouter au panier',
        out_of_stock: 'Rupture de stock',
        buy_now: 'Acheter maintenant',
        proceed_to_checkout: 'Passer au paiement',
        continue_shopping: 'Continuer les achats',
        remove: 'Retirer',
        move_to_bag: 'Déplacer vers le panier',
        share: 'Partager',
        quick_view: 'Aperçu rapide',
        loading: 'Chargement...',
        subtotal: 'Sous-total',
        shipping: 'Livraison',
        free: 'Gratuit',
        total: 'Total',
        discount: 'Remise',
        added_to_wishlist: 'Ajouté aux favoris',
        removed_from_wishlist: 'Retiré des favoris',
        added_to_bag: 'ajouté au panier',
      },
      product: {
        recommendations: 'Vous aimerez aussi',
        recently_viewed: 'Vus récemment',
        related: 'Produits similaires',
        in_stock: 'En stock',
        rating: 'Note',
        reviews: 'avis',
        details: 'Détails',
        shipping: 'Livraison',
      },
      wishlist: {
        title: 'Vos favoris',
        subtitle: 'Articles enregistrés pour vous',
        empty_title: 'Votre liste de favoris est vide',
        empty_subtitle: 'Enregistrez vos articles préférés en appuyant sur le cœur.',
        browse_shop: 'Parcourir la boutique',
        items_saved: '{{count}} articles enregistrés',
        move_all_to_bag: 'Tout déplacer vers le panier',
        clear: 'Vider les favoris',
      },
      cart: {
        title: 'Votre panier',
        empty_title: 'Votre panier est vide',
        empty_subtitle: "Remplissons-le d'espoir et de grâce.",
        clear_bag: 'Vider le panier',
        start_shopping: 'Commencer les achats',
      },
      footer: {
        newsletter_title: "Abonnez-vous pour recevoir de l'espoir",
        newsletter_placeholder: 'Entrez votre email',
        subscribe: "S'abonner",
      },
    },
  },
};

// Migrate legacy stored value 'hi' → 'en' (Hindi removed for US market).
let stored = 'en';
try {
  const s = (typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || 'en';
  stored = ['en', 'es', 'fr'].includes(s) ? s : 'en';
  if (s === 'hi') localStorage.setItem(STORAGE_KEY, 'en');
} catch { /* noop */ }

i18n.use(initReactI18next).init({
  resources,
  lng: stored,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export const supportedLanguages = [
  { code: 'en', label: 'English', native: 'English' },
  { code: 'es', label: 'Spanish', native: 'Español' },
  { code: 'fr', label: 'French',  native: 'Français' },
];

export const setLanguage = (code) => {
  i18n.changeLanguage(code);
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* noop */ }
};

export default i18n;
